import React, { Component } from 'react';
import { connect } from 'react-redux';
import '../index.scss';
import CommonTitle from './common-title/index';
class Placeholder extends Component {
  render() {

    const { picUrl, title } = this.props;

    return (
      <div className="placeholder">
        <CommonTitle title={title}></CommonTitle>
        <img className="placeholder__pic" src={picUrl} alt=""></img>
      </div>
    )
  }
}

export default connect(null, null)(Placeholder);
